import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';

import { ApiService } from './api.service';
import { ConteudoModel } from '../models';
import { map, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConteudoService {
  constructor(private apiService: ApiService) {}

  add(conteudo: ConteudoModel): Observable<ConteudoModel> {
    return this.apiService.post(`/conteudo`, { conteudo }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getAll(limit?: number): Observable<ConteudoModel[]> {
    const path = limit ? `/conteudos/&limit=${limit}` : `/conteudos`;
    return this.apiService.get(path);
  }

  getById(id: number): Observable<ConteudoModel> {
    return this.apiService.get(`/conteudos/${id}`);
  }

  update(conteudo: ConteudoModel): Observable<ConteudoModel> {
    const { id } = conteudo;
    return this.apiService.put(`/conteudos/${id}`, conteudo).pipe(
      map((data) => {
        return data;
      })
    );
  }

  delete(id: string) {
    return this.apiService.delete(`/conteudos/${id}`).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
